export default "__VITE_ASSET__59506185__"